<template>
    <div v-if="group"
         class="group-info-list text-primary"
         :width="width ? width : 'auto'">
        <div class="group-info d-flex flex-row text-h6">
            <div class="text-primary">Название:</div>
            <div class="text-lonely">{{group.name}}</div>
        </div>
        <div class="group-info d-flex flex-row text-h6">
            <div class="text-primary">Описание:</div>
            <div class="text-lonely">{{group.description}}</div>
        </div>
        <div class="group-info d-flex flex-row text-h6">
            <div class="text-primary">Guid:</div>
            <div class="text-lonely">{{group.guid}}</div>
        </div>
        <div class="group-info d-flex flex-row text-h6">
            <div class="text-primary">Создатель:</div>
            <div class="text-lonely">{{group.creator.userName}}</div>
        </div>
        <div class="group-info d-flex flex-row text-h6">
            <div class="text-primary">Дата создания:</div>
            <div class="text-lonely">{{getDate(group.createdDate)}}</div>
        </div>
        <div class="group-info d-flex flex-row text-h6">
            <div class="text-primary">Время создания:</div>
            <div class="text-lonely">{{getTime(group.createdDate)}}</div>
        </div>
        <div class="group-info d-flex flex-row text-h6">
            <div class="text-primary">Количество участников:</div>
            <div class="text-lonely">{{group.membersCount}}</div>
        </div>
    </div>
</template>

<script>
import { DateTime } from "luxon";

export default {
        props: {
            group: Object,
            width: String
        },

        computed: {
            currentLocale() {
                return this.$store.state.currentLocale;
            }
        },

        methods: {
            getDate(isoDateTime) {
                return DateTime.fromISO(isoDateTime).setLocale(this.currentLocale).toFormat("yyyy.MM.dd");
            },
            getTime(isoDateTime) {
                return DateTime.fromISO(isoDateTime).setLocale(this.currentLocale).toFormat("HH:mm");
            }
        }
};
</script>

<style lang="scss">
    .group-info-list .group-info div.text-primary {
        min-width: 250px;
    }
</style>